import { ReactComponent as JudicialApartmentsIcon } from "./assets/images/efraz/judicialApartments.svg";
import { ReactComponent as JudicialLandsIcon } from "./assets/images/efraz/judicialLands.svg";
import { ReactComponent as MergeApartmentsIcon } from "./assets/images/efraz/mergeApartments.svg";
import { ReactComponent as MergeLandsIcon } from "./assets/images/efraz/mergeLands.svg";
import { ReactComponent as PartnerApartmentsIcon } from "./assets/images/efraz/partnerApartments.svg";
import { ReactComponent as PartnerLandsIcon } from "./assets/images/efraz/partnerLands.svg";
import { ReactComponent as SellingApartmentsIcon } from "./assets/images/efraz/sellingApartments.svg";
import { ReactComponent as SellingLandsIcon } from "./assets/images/efraz/sellingLands.svg";
import { ReactComponent as SplitApartmentsIcon } from "./assets/images/efraz/splitApartments.svg";
import { ReactComponent as SplitLandsIcon } from "./assets/images/efraz/splitLands.svg";
import { ReactComponent as DeleteOffice } from "./assets/images/legalAffairs/deleteOffice.svg";
import { ReactComponent as DeleteRenewEstimator } from "./assets/images/legalAffairs/deleteRenewEstimator.svg";
import { ReactComponent as DeleteServey } from "./assets/images/legalAffairs/deleteServey.svg";
import { ReactComponent as GiveEstimator } from "./assets/images/legalAffairs/giveEstimator.svg";
import { ReactComponent as GiveOffice } from "./assets/images/legalAffairs/giveOffice.svg";
import { ReactComponent as GiveServey } from "./assets/images/legalAffairs/giveServey.svg";
import { ReactComponent as RenewOffice } from "./assets/images/legalAffairs/renewOffice.svg";
import { ReactComponent as RenewServey } from "./assets/images/legalAffairs/renewServey.svg";
import { ReactComponent as AgencyAccreditationIcon } from "./assets/images/ownership-transfer/agencyAccreditation.svg";
import { ReactComponent as CourtSellingIcon } from "./assets/images/ownership-transfer/courtSelling.svg";
import { ReactComponent as DeceasedAgentIcon } from "./assets/images/ownership-transfer/deceasedAgent.svg";
import { ReactComponent as FinanceLeaseCancelIcon } from "./assets/images/ownership-transfer/financeleaseCancel.svg";
import { ReactComponent as FinanceLeaseDocumentationIcon } from "./assets/images/ownership-transfer/financeleaseDocumentation.svg";
import { ReactComponent as FinanceLeaseReplaceIcon } from "./assets/images/ownership-transfer/financeleaseReplace.svg";
import { ReactComponent as FinanceLeaseSellingIcon } from "./assets/images/ownership-transfer/financeleaseSelling.svg";
import { ReactComponent as InstallmentSellingIcon } from "./assets/images/ownership-transfer/installmentSelling.svg";
import { ReactComponent as MortgageIcon } from "./assets/images/ownership-transfer/mortgage.svg";
import { ReactComponent as MortgageReleaseIcon } from "./assets/images/ownership-transfer/mortgageRelease.svg";
import { ReactComponent as MortgageSellingIcon } from "./assets/images/ownership-transfer/mortgageSelling.svg";
import { ReactComponent as MortgageTransferIcon } from "./assets/images/ownership-transfer/mortgageTransfer.svg";
import { ReactComponent as PromiseToSellIcon } from "./assets/images/ownership-transfer/promiseToSell.svg";
import { ReactComponent as PublicEndowmentIcon } from "./assets/images/ownership-transfer/publicEndowment.svg";
import { ReactComponent as RefundFeesIcon } from "./assets/images/ownership-transfer/refundFees.svg";
import { ReactComponent as RelativesEndowmentIcon } from "./assets/images/ownership-transfer/relativesEndowment.svg";
import { ReactComponent as ReRegisterIcon } from "./assets/images/ownership-transfer/reRegister.svg";
import { ReactComponent as SellingAqabaIcon } from "./assets/images/ownership-transfer/sellingAqaba.svg";
import { ReactComponent as SellingJordanValleyIcon } from "./assets/images/ownership-transfer/sellingJordanValley.svg";
import { ReactComponent as SellingPetraIcon } from "./assets/images/ownership-transfer/sellingPetra.svg";
import { ReactComponent as SellingUrbanDevIcon } from "./assets/images/ownership-transfer/sellingUrbanDev.svg";
import { ReactComponent as TransmissionIcon } from "./assets/images/ownership-transfer/transmission.svg";
import { ReactComponent as TransmissionTakharogIcon } from "./assets/images/ownership-transfer/transmissionTakharog.svg";
import { ReactComponent as WillDocumentIcon } from "./assets/images/ownership-transfer/willDocument.svg";
import { ReactComponent as AgencyQoushan } from "./assets/images/quick-services/agencyQoushan.svg";
import { ReactComponent as ChangeStatement } from "./assets/images/quick-services/changeStatement.svg";
import { ReactComponent as LandPlan } from "./assets/images/quick-services/landPlan.svg";
import { ReactComponent as PropertyDisclousre } from "./assets/images/quick-services/propertyDisclousre.svg";
import { ReactComponent as PropertyOwnership } from "./assets/images/quick-services/propertyOwnership.svg";
import { ReactComponent as RegisteredProperty } from "./assets/images/quick-services/registeredProperty.svg";
import { ReactComponent as SellingIcon } from "./assets/images/selling.svg";
import i18n from "./i18n";

// import i18n from "i18next"
// export default config

const data = { config: {} };

function updateTranslations() {
  const config = {
    IN_DEV_PASS: "5aoA*^h&KTUA7Q",
    IN_DEV_PASS_KEY: "IN_DEV_PASS_KEY",
    apiUrl: process.env.REACT_APP_API_URL,
    showElectricityClearance: true,
    googleCaptchaToken: process.env.REACT_APP_GOOGLE_CAPTCHA,
    userTypes: [
      { label: i18n.t("realtySelling.self"), value: 1 },
      { label: i18n.t("realtySelling.agent"), value: 2 },
      { label: i18n.t("realtySelling.guardian"), value: 3 },
      { label: i18n.t("realtySelling.deputy"), value: 4 },
    ],
    userTypesNew: [
      // { label: i18n.t("realtySelling.empty"), value: -1 },
      { label: i18n.t("realtySelling.self"), value: 1 },
      { label: i18n.t("realtySelling.agent"), value: 2 },
      { label: i18n.t("realtySelling.guardianAdj"), value: 3 },
      { label: i18n.t("realtySelling.custodian"), value: 5 },
      { label: i18n.t("realtySelling.deputy"), value: 4 },
    ],
    maxFileSize: 5 * 1024 * 1024,
    sanadStationsUrl: "https://www.sanad.gov.jo/Ar/Pages/SanadStations",
    dlsPortalUrl:
      "https://eservices.dls.gov.jo/dlseservices/faces/new_user_registration",
    breakdowns: {
      MOBILE_MAX_WIDTH: 768,
      TABLET_MAX_WIDTH: 992,
      DESKTOP_MIN_WIDTH: 768,
    },
    quickServicesSelect: {
      governorate: [
        {
          label: "عمان",
          value: " AMM",
        },
        {
          label: "اربد",
          value: " IRB",
        },
        {
          label: "جرش",
          value: "Jerash",
        },
      ],
      directorate: [
        {
          label: "عمان",
          value: " AMM",
        },
        {
          label: "اربد",
          value: " IRB",
        },
        {
          label: "جرش",
          value: "Jerash",
        },
      ],
      village: [
        {
          label: "عمان",
          value: " AMM",
        },
        {
          label: "اربد",
          value: " IRB",
        },
        {
          label: "جرش",
          value: "Jerash",
        },
      ],
      trough: [
        {
          label: "عمان",
          value: " AMM",
        },
        {
          label: "اربد",
          value: " IRB",
        },
        {
          label: "جرش",
          value: "Jerash",
        },
      ],
      neighbourhood: [
        {
          label: "عمان",
          value: " AMM",
        },
        {
          label: "اربد",
          value: " IRB",
        },
        {
          label: "جرش",
          value: "Jerash",
        },
      ],
      piece: [
        {
          label: "عمان",
          value: " AMM",
        },
        {
          label: "اربد",
          value: " IRB",
        },
        {
          label: "جرش",
          value: "Jerash",
        },
      ],
      drawingScale: [
        {
          label: "عمان",
          value: " AMM",
        },
        {
          label: "اربد",
          value: " IRB",
        },
        {
          label: "جرش",
          value: "Jerash",
        },
      ],
    },
    serviceID: [
      { id: 1, label: i18n.t("quickServices.serviceAction") },
      { id: 2, label: i18n.t("quickServices.qushanTitle") },
      { id: 3, label: i18n.t("quickServices.landPlanningTitle") },
      { id: 6, label: i18n.t("quickServices.qushanAgent") },
      { id: 7, label: i18n.t("quickServices.changeStatementTitle") },
      { id: 8, label: i18n.t("quickServices.noProperty") },
    ],
    newServiceID: [
      { id: 161, label: i18n.t("quickServices.qushanAgent") },
      { id: 162, label: i18n.t("quickServices.landPlanningTitle") },
      { id: 163, label: i18n.t("quickServices.qushanTitle") },
      { id: 164, label: i18n.t("quickServices.landPlanningCoordinates") },
      { id: 165, label: i18n.t("quickServices.landPlanningChange") },
      { id: 166, label: i18n.t("quickServices.landPlanningChangeCoordinates") },
      { id: 167, label: i18n.t("quickServices.serviceAction") },
      { id: 168, label: i18n.t("quickServices.noProperty") },
      { id: 169, label: i18n.t("quickServices.changeStatementTitle") },
      { id: 170, label: i18n.t("quickServices.coordinates") },
      { id: 171, label: i18n.t("quickServices.qushanLandPlanning") },
      { id: 172, label: i18n.t("quickServices.qushanLandPlanningCoordinates") },
      {
        id: 173,
        label: i18n.t("quickServices.qushanLandPlanningCoordinatesChange"),
      },
      { id: 174, label: i18n.t("quickServices.qushanLandPlanningChange") },
    ],
    requestStatusID: [
      { id: 1, label: i18n.t("quickServices.awaitingPayment") },
      { id: 2, label: i18n.t("quickServices.paid") },
      { id: 3, label: i18n.t("quickServices.requestCanceled") },
      { id: 4, label: i18n.t("quickServices.waitingForApproval") },
      { id: 5, label: i18n.t("quickServices.approved") },
      { id: 6, label: i18n.t("quickServices.rejected") },
      { id: 7, label: i18n.t("quickServices.completeRequest") },
    ],
    newRequestStatusID: [
      { id: 1, label: i18n.t("quickServices.awaitingPayment") },
      { id: 2, label: i18n.t("quickServices.paid") },
      { id: 3, label: i18n.t("quickServices.printed") },
    ],
    testRequest: ["في إنتظار الدفع", "تم الدفع", "الطلب ملغي"],
    changePasswordLink:
      "https://eservices.dls.gov.jo/dlseservices/faces/my_account",
    servicesItems: [
      {
        label: i18n.t("sideBarGov.quick"),
        key: "quick-services",
        release: "1",
      },
      {
        label: i18n.t("sideBarGov.transportation"),
        key: "ownership-transfer",
        release: "1",
      },
      {
        label: i18n.t("sideBarGov.Efraz"),
        key: "efraz",
        release: "1",
      },
      {
        label: i18n.t("sideBarGov.mortgageAndFinance"),
        key: "mortgageAndFinance",
        release: "1",
      },
      {
        label: i18n.t("sideBarGov.realEstateOffice"),
        key: "real-estate-office",
        release: "1",
      },

      {
        label: i18n.t("sideBarGov.realEstateAppraiser"),
        key: "real-estate-appraiser",
        release: "1",
      },
      {
        label: i18n.t("sideBarGov.licensedSurveyor"),
        key: "surveyor",
        release: "1",
      },
      // {
      //   label: i18n.t("sideBarGov.investmentServices"),
      //   key: "investmentServices",
      //   release: "1",
      //   type: "link",
      //   href: `https://eservices.dls.gov.jo/dlseservices/faces/main_page`,
      // },
      {
        label: i18n.t("sideBarGov.investmentServices"),
        key: "investmentServicesImproved",
        release: "1",
        // type: "link",
        // href: `https://eservices.dls.gov.jo/dlseservices/faces/main_page`,
      },
      {
        label: i18n.t("sideBarGov.agenciesOfAllKinds"),
        key: "agencies",
        release: "1",
      },
      {
        label: i18n.t("sideBarGov.surveyServices"),
        key: "survey",
        release: "1",
      },
      {
        label: i18n.t("sideBarGov.registrationServices"),
        key: "registrationServices",
        release: "1",
      },
      {
        label: i18n.t("sideBarGov.govPropertyManagement"),
        key: "govPropertyManagement",
        release: "1",
      },
      // {
      //   label: i18n.t("sideBarGov.servicesInDevelopment"),
      //   key: "servicesInDevelopment",
      //   release: "1",
      // },
      {
        label: i18n.t("sideBarGov.reservationAndRelease"),
        key: "block",
        disable: true,
      },
      {
        label: i18n.t("sideBarGov.InvestigationOfImmovableProperty"),
        key: "immovable-property",
        disable: true,
      },

      {
        label: i18n.t("sideBarGov.roadsAndLandSettlement"),
        key: "road-land-leveling",
        disable: true,
      },
      {
        label: i18n.t("sideBarGov.ownerInformationCorrection"),
        key: "owner-information-correction",
        disable: true,
      },

      {
        label: i18n.t("sideBarGov.rightsSettlement"),
        key: "rights-settlement",
        disable: true,
      },

      {
        label: i18n.t("sideBarGov.secretion"),
        key: "land-sort",
        disable: true,
      },
      {
        label: i18n.t("sideBarGov.acquisition"),
        key: "acquisitions",
        disable: true,
      },
      {
        label: i18n.t("sideBarGov.other"),
        key: "other-services",
        disable: true,
      },
    ],
    services: [
      // Quick Services
      {
        label: i18n.t("quickServices.qushanTitle"),
        icon: <RegisteredProperty />,
        startUrl:
          "/government-services/dls/quick-services/registered-property/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/registered-property/description",
        requirementsUrl:
          "/government-services/dls/quick-services/registered-property/requirements",
        category: "quick-services",
        release: "1",
        userManualUrl: "/User_Manuals/Quick_Services/إصدار_قوشان.pdf",
        userManualName: "إصدار قوشان",
        published: true,
      },
      {
        label: i18n.t("quickServices.qushanTitle"),
        icon: <RegisteredProperty />,
        startUrl:
          "/government-services/dls/quick-services/registered-property-new/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/registered-property-new/description",
        requirementsUrl:
          "/government-services/dls/quick-services/registered-property-new/requirements",
        category: "servicesInDevelopment",
        release: "1",
        userManualUrl: "/User_Manuals/Quick_Services/إصدار_قوشان.pdf",
        userManualName: "إصدار قوشان",
        published: true,
      },
      {
        label: i18n.t("quickServices.requestPropertyStatement"),
        icon: <PropertyDisclousre />,
        startUrl:
          "/government-services/dls/quick-services/property-disclousre/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/property-disclousre/description",
        requirementsUrl:
          "/government-services/dls/quick-services/property-disclousre/requirements",
        category: "quick-services",
        release: "1",
        userManualUrl: "/User_Manuals/Quick_Services/إصدار_كشف_أملاك.pdf",
        userManualName: "إصدار كشف أملاك",
        published: true,
      },
      {
        label: i18n.t("quickServices.requestPropertyStatement"),
        icon: <PropertyDisclousre />,
        startUrl:
          "/government-services/dls/quick-services/property-disclousre-new/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/property-disclousre-new/description",
        requirementsUrl:
          "/government-services/dls/quick-services/property-disclousre-new/requirements",
        category: "servicesInDevelopment",
        release: "1",
        userManualUrl: "/User_Manuals/Quick_Services/إصدار_كشف_أملاك.pdf",
        userManualName: "إصدار كشف أملاك",
        published: true,
      },
      {
        label: i18n.t("quickServices.landPlanningTitle"),
        icon: <LandPlan />,
        startUrl: "/government-services/dls/quick-services/land-planning/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/land-planning/description",
        requirementsUrl:
          "/government-services/dls/quick-services/land-planning/requirements",
        category: "quick-services",
        release: "1",
        userManualUrl: "/User_Manuals/Quick_Services/إخراج_مخطط_أراضي.pdf",
        userManualName: "إخراج مخطط أراضي",
        published: true,
        name: "land-planning",
      },
      {
        label: i18n.t("quickServices.landPlanningTitle"),
        icon: <LandPlan />,
        startUrl:
          "/government-services/dls/quick-services/land-planning-new/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/land-planning-new/description",
        requirementsUrl:
          "/government-services/dls/quick-services/land-planning-new/requirements",
        category: "servicesInDevelopment",
        release: "1",
        userManualUrl: "/User_Manuals/Quick_Services/إخراج_مخطط_أراضي.pdf",
        userManualName: "إخراج مخطط أراضي",
        published: true,
        name: "land-planning-new",
      },
      {
        label: i18n.t("quickServices.qushanAgent"),
        icon: <AgencyQoushan />,
        startUrl:
          "/government-services/dls/quick-services/qushan-agencies/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/qushan-agencies/-description",
        requirementsUrl:
          "/government-services/dls/quick-services/qushan-agencies/requirements",
        category: "quick-services",
        release: "1",
        hide: true,
      },
      {
        label: i18n.t("quickServices.qushanAgent"),
        icon: <AgencyQoushan />,
        startUrl:
          "/government-services/dls/quick-services/qushan-agencies-new/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/qushan-agencies-new/-description",
        requirementsUrl:
          "/government-services/dls/quick-services/qushan-agencies-new/requirements",
        category: "servicesInDevelopment",
        release: "1",
        hide: true,
      },
      {
        label: i18n.t("quickServices.changeStatementTitle"),
        icon: <ChangeStatement />,
        startUrl:
          "/government-services/dls/quick-services/change-statement/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/change-statement/description",
        requirementsUrl:
          "/government-services/dls/quick-services/change-statement/requirements",
        category: "quick-services",
        release: "1",
        hide: true,
      },
      {
        label: i18n.t("quickServices.changeStatementTitle"),
        icon: <ChangeStatement />,
        startUrl:
          "/government-services/dls/quick-services/change-statement-new/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/change-statement-new/description",
        requirementsUrl:
          "/government-services/dls/quick-services/change-statement-new/requirements",
        category: "servicesInDevelopment",
        release: "1",
        hide: true,
      },
      {
        label: i18n.t("quickServices.noProperty"),
        icon: <PropertyOwnership />,
        startUrl: "/government-services/dls/quick-services/no-properties/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/no-properties/description",
        requirementsUrl:
          "/government-services/dls/quick-services/no-properties/requirements",
        category: "quick-services",
        release: "1",
        userManualUrl:
          "/User_Manuals/Quick_Services/إصدار_شهادة_عدم_وجود_أملاك.pdf",
        userManualName: "إصدار شهادة عدم وجود أملاك",
        published: true,
      },
      {
        label: i18n.t("quickServices.noProperty"),
        icon: <PropertyOwnership />,
        startUrl:
          "/government-services/dls/quick-services/no-properties-new/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/no-properties-new/description",
        requirementsUrl:
          "/government-services/dls/quick-services/no-properties-new/requirements",
        category: "servicesInDevelopment",
        release: "1",
        userManualUrl:
          "/User_Manuals/Quick_Services/إصدار_شهادة_عدم_وجود_أملاك.pdf",
        userManualName: "إصدار شهادة عدم وجود أملاك",
        published: true,
      },
      {
        label: i18n.t("quickServices.registeredPropertyAuthorization"),
        icon: <PropertyOwnership />,
        startUrl:
          "/government-services/dls/quick-services/registered-property-authorization/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/registered-property-authorization/description",
        requirementsUrl:
          "/government-services/dls/quick-services/registered-property-authorization/requirements",
        category: "quick-services",
        release: "1",
        userManualUrl:
          "/User_Manuals/Quick_Services/خدمة إخراج قيد للوكالات.pdf",
        userManualName: "خدمة إخراج قيد للوكالات",
        published: true,
      },
      {
        label: i18n.t("quickServices.registeredPropertyAuthorizationNew"),
        icon: <PropertyOwnership />,
        startUrl:
          "/government-services/dls/quick-services/registered-property-authorization-new/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/registered-property-authorization-new/description",
        requirementsUrl:
          "/government-services/dls/quick-services/registered-property-authorization-new/requirements",
        category: "servicesInDevelopment",
        release: "1",
        userManualUrl:
          "/User_Manuals/Quick_Services/خدمة إخراج قيد للوكالات.pdf",
        userManualName: "خدمة إخراج قيد للوكالات",
        published: true,
      },
      {
        label: i18n.t("quickServices.changeStatement"),
        icon: <PropertyOwnership />,
        startUrl:
          "/government-services/dls/quick-services/change-statement/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/change-statement/description",
        requirementsUrl:
          "/government-services/dls/quick-services/change-statement/requirements",
        category: "quick-services",
        release: "1",
        userManualUrl: "/User_Manuals/Quick_Services/خدمة بيان تغيير.pdf",
        userManualName: "خدمة بيان تغيير",
        published: true,
        subTitle: i18n.t("quickServices.freeForLicensedSurveyors"),
      },
      {
        label: i18n.t("quickServices.provideLandCoordinatesTitle"),
        icon: <RegisteredProperty />,
        startUrl:
          "/government-services/dls/quick-services/provide-land-coordinates/apply",
        // descriptionUrl:
        //   "/government-services/dls/quick-services/registered-property/description",
        // requirementsUrl:
        //   "/government-services/dls/quick-services/registered-property/requirements",
        // category: "quick-services",
        category: "quick-services",
        release: "1",
        published: true,
        // userManualUrl: "/User_Manuals/Quick_Services/إصدار_قوشان.pdf",
        // userManualName: "إصدار قوشان",
      },
      {
        label: i18n.t("quickServices.changeStatement"),
        icon: <PropertyOwnership />,
        startUrl:
          "/government-services/dls/quick-services/change-statement-new/apply",
        descriptionUrl:
          "/government-services/dls/quick-services/change-statement-new/description",
        requirementsUrl:
          "/government-services/dls/quick-services/change-statement-new/requirements",
        category: "servicesInDevelopment",
        release: "1",
        userManualUrl: "/User_Manuals/Quick_Services/خدمة بيان تغيير.pdf",
        userManualName: "خدمة بيان تغيير",
        published: true,
        subTitle: i18n.t("quickServices.freeForLicensedSurveyors"),
      },
      // {
      //   label: i18n.t("login.newUser"),
      //   icon: <PropertyOwnership />,
      //   startUrl:
      //     "/signup",
      //   // descriptionUrl:
      //   //   "/government-services/dls/quick-services/change-statement-new/description",
      //   // requirementsUrl:
      //   //   "/government-services/dls/quick-services/change-statement-new/requirements",
      //   category: "servicesInDevelopment",
      //   release: "1",
      //   // userManualUrl: "/User_Manuals/Quick_Services/خدمة بيان تغيير.pdf",
      //   // userManualName: "خدمة بيان تغيير",
      //   published: true,
      // },
      // Ownership Transfer Services
      {
        label: i18n.t("services.selling"),
        serviceTitle: i18n.t("services.selling"),
        desc: i18n.t("realtySelling.serviceDesc"),
        name: "selling",
        icon: <SellingIcon />,
        startUrl: "/government-services/dls/ownership-transfer/selling/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/selling/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/selling/requirements",
        category: "ownership-transfer",
        release: "1",
        showAtMyProperties: true,
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/Selling_User_Manual_V3.0.pdf",
        userManualName: "دليل المستخدم خدمة البيع",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.installmentSelling.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.installmentSelling.titleService",
        ),
        desc: i18n.t("OwnershipTransfer.installmentSelling.serviceDesc"),
        name: "installmentSelling",
        icon: <InstallmentSellingIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/installment-selling/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/installment-selling/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/installment-selling/requirements",
        category: "ownership-transfer",
        release: "1",
        showAtMyProperties: true,
        disableByDistrict: true,
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة البيع بالتقسيط.pdf",
        userManualName: "دليل المستخدم خدمة بيع التقسيط",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.courtsSelling.title"),
        serviceTitle: i18n.t("OwnershipTransfer.courtsSelling.titleService"),
        desc: i18n.t("OwnershipTransfer.courtsSelling.serviceDesc"),
        name: "courtsSelling",
        icon: <CourtSellingIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/courts-selling/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/courts-selling/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/courts-selling/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة بيع المحاكم.pdf",
        userManualName: "دليل المستخدم خدمة بيع المحاكم",
        row: 1,
      },
      {
        label: i18n.t("OwnershipTransfer.mortgageSelling.title"),
        serviceTitle: i18n.t("OwnershipTransfer.mortgageSelling.titleService"),
        desc: i18n.t("OwnershipTransfer.mortgageSelling.serviceDesc"),
        name: "mortgageSelling",
        icon: <MortgageSellingIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/selling-with-mortgage/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/selling-with-mortgage/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/selling-with-mortgage/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة بيع مع تأمين.pdf",
        userManualName: "دليل المستخدم خدمة بيع مع تأمين",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.promiseToSell.title"),
        serviceTitle: i18n.t("OwnershipTransfer.promiseToSell.titleService"),
        desc: i18n.t("OwnershipTransfer.promiseToSell.serviceDesc"),
        name: "promiseToSell",
        icon: <PromiseToSellIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/promise-to-sell/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/promise-to-sell/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/promise-to-sell/requirements",
        category: "ownership-transfer",
        release: "1",
        showAtMyProperties: true,
        disableByDistrict: true,
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة الوعد بالبيع.pdf",
        userManualName: "دليل المستخدم خدمة الوعد بالبيع",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.reregister.title"),
        serviceTitle: i18n.t("OwnershipTransfer.reregister.titleService"),
        desc: i18n.t("OwnershipTransfer.reregister.serviceDesc"),
        name: "reregister",
        icon: <ReRegisterIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/re-register/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/re-register/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/re-register/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة إعادة تسجيل.pdf",
        userManualName: "دليل المستخدم خدمة إعادة التسجيل",
        row: 1,
      },
      {
        label: i18n.t("OwnershipTransfer.Endowment.title"),
        serviceTitle: i18n.t("OwnershipTransfer.Endowment.serviceTitle"),
        desc: i18n.t("OwnershipTransfer.Endowment.serviceDesc"),
        name: "publicEndowment",
        icon: <PublicEndowmentIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/publicEndowment/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/publicEndowment/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/publicEndowment/requirements",
        category: "ownership-transfer",
        release: "1",
        showAtMyProperties: true,
        disableByDistrict: true,
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة الوقف الصحيح.pdf",
        userManualName: "دليل المستخدم خدمة الوقف الصحيح",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.Endowment.relativesTitle"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.Endowment.relativesServiceTitle",
        ),
        desc: i18n.t("OwnershipTransfer.Endowment.relativesServiceDesc"),
        name: "relativesEndowment",
        icon: <RelativesEndowmentIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/relativesEndowment/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/relativesEndowment/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/relativesEndowment/requirements",
        category: "ownership-transfer",
        release: "1",
        showAtMyProperties: true,
        disableByDistrict: true,
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة الوقف الذرى.pdf",
        userManualName: "دليل المستخدم خدمة الوقف الذري",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.AuthSelling.Aseza.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.AuthSelling.Aseza.serviceTitle",
        ),
        desc: i18n.t("OwnershipTransfer.AuthSelling.Aseza.serviceDesc"),
        name: "asezaSelling",
        icon: <SellingAqabaIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/asezaSelling/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/asezaSelling/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/asezaSelling/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة بيع سلطة منطقة العقبة.pdf",
        userManualName: "دليل المستخدم خدمة بيع سلطة منطقة العقبة",
        row: 2,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.AuthSelling.JVA.title"),
        serviceTitle: i18n.t("OwnershipTransfer.AuthSelling.JVA.serviceTitle"),
        desc: i18n.t("OwnershipTransfer.AuthSelling.JVA.serviceDesc"),
        name: "jvaSelling",
        icon: <SellingJordanValleyIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/jvaSelling/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/jvaSelling/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/jvaSelling/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة بيع سلطة وادي الأردن.pdf",
        userManualName: "دليل المستخدم خدمة بيع سلطة وادي الأردن",
        row: 2,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.AuthSelling.Petra.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.AuthSelling.Petra.serviceTitle",
        ),
        desc: i18n.t("OwnershipTransfer.AuthSelling.Petra.serviceDesc"),
        name: "petraSelling",
        icon: <SellingPetraIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/petraSelling/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/petraSelling/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/petraSelling/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة بيع سلطة إقليم البتراء.pdf",
        userManualName: "دليل المستخدم خدمة بيع سلطة البتراء",
        row: 2,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.AuthSelling.UrbanDev.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.AuthSelling.UrbanDev.serviceTitle",
        ),
        desc: i18n.t("OwnershipTransfer.AuthSelling.UrbanDev.serviceDesc"),
        name: "urbanSelling",
        icon: <SellingUrbanDevIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/urbanSelling/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/urbanSelling/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/urbanSelling/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/بيع مؤسسة التطوير الحضري.pdf",
        userManualName: "دليل المستخدم خدمة بيع مؤسسة التطوير الحضري",
        row: 2,
        published: true,
      },
      {
        label: i18n.t(
          "OwnershipTransfer.Transmission.transmissionTakharogTitle",
        ),
        serviceTitle: i18n.t(
          "OwnershipTransfer.Transmission.transmissionTakharogServiceTitle",
        ),
        desc: i18n.t(
          "OwnershipTransfer.Transmission.transmissionTakharogServiceDesc",
        ),
        name: "transmissionTakharog",
        icon: <TransmissionTakharogIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/transmissionTakharog/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/transmissionTakharog/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/transmissionTakharog/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة التخارج والإنتقال.pdf",
        userManualName: "دليل المستخدم خدمة التخارج والانتقال",
        row: 3,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.Transmission.title"),
        serviceTitle: i18n.t("OwnershipTransfer.Transmission.serviceTitle"),
        desc: i18n.t("OwnershipTransfer.Transmission.serviceDesc"),
        name: "transmission",
        icon: <TransmissionIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/transmission/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/transmission/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/transmission/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl: "/User_Manuals/Ownership_User_Manual/خدمة الإنتقال.pdf",
        userManualName: "دليل المستخدم خدمة الانتقال",
        row: 3,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.Transmission.deceasedAgentTitle"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.Transmission.deceasedAgentServiceTitle",
        ),
        desc: i18n.t("OwnershipTransfer.Transmission.deceasedAgentServiceDesc"),
        name: "registrationOfDeceasedAgent",
        icon: <DeceasedAgentIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/registration-of-deceased-agent/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/registration-of-deceased-agent/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/registration-of-deceased-agent/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/تسجيل حقوق وكيل متوفي.pdf",
        userManualName: "دليل المستخدم خدمة تسجيل حقوق وكيل متوفى",
        row: 3,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.willDocumentation.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.willDocumentation.titleService",
        ),
        desc: i18n.t("OwnershipTransfer.willDocumentation.serviceDesc"),
        name: "willDocumentation",
        icon: <WillDocumentIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/will-documentation/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/will-documentation/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/will-documentation/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl: "/User_Manuals/Ownership_User_Manual/توثيق وصية.pdf",
        userManualName: "دليل المستخدم خدمة توثيق وصية",
        row: 3,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.FinanceLease.title"),
        serviceTitle: i18n.t("OwnershipTransfer.FinanceLease.serviceTitle"),
        desc: i18n.t("OwnershipTransfer.FinanceLease.serviceDesc"),
        name: "financeLease",
        icon: <FinanceLeaseDocumentationIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/financeLease/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/financeLease/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/financeLease/requirements",
        category: "mortgageAndFinance",
        release: "1",
        showAtMyProperties: true,
        disableByDistrict: true,
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/بيع لغايات التاجير التمويلي.pdf",
        userManualName: "دليل المستخدم خدمة بيع لغايات التاجير التمويلي",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.FinanceLease.titleDoc"),
        serviceTitle: i18n.t("OwnershipTransfer.FinanceLease.serviceTitleDoc"),
        desc: i18n.t("OwnershipTransfer.FinanceLease.serviceDescDoc"),
        name: "financeLeaseDoc",
        icon: <FinanceLeaseDocumentationIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/financeLease-documentaion/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/financeLease-documentaion/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/financeLease-documentaion/requirements",
        category: "mortgageAndFinance",
        release: "1",
        showAtMyProperties: true,
        disableByDistrict: true,
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/بيع لغايات التاجير التمويلي.pdf",
        userManualName: "دليل المستخدم خدمة بيع لغايات التاجير التمويلي",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.FinanceLeaseReplace.titleTenant"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.FinanceLeaseReplace.serviceTitleTenant",
        ),
        desc: i18n.t("OwnershipTransfer.FinanceLeaseReplace.serviceDescTenant"),
        name: "financeLeaseReplaceTenant",
        icon: <FinanceLeaseReplaceIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/financeLease-tenant-replace/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/financeLease-tenant-replace/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/financeLease-tenant-replace/requirements",
        category: "mortgageAndFinance",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/إحلال عقد تأجير تمويلي.pdf",
        userManualName: "دليل المستخدم خدمة إحلال عقد تأجير تمويلي",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.FinanceLeaseReplace.titleLandlord"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.FinanceLeaseReplace.serviceTitleLandlord",
        ),
        desc: i18n.t(
          "OwnershipTransfer.FinanceLeaseReplace.serviceDescLandlord",
        ),
        name: "financeLeaseReplaceLandlord",
        icon: <FinanceLeaseReplaceIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/financeLease-landlord-replace/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/financeLease-landlord-replace/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/financeLease-landlord-replace/requirements",
        category: "mortgageAndFinance",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/إحلال عقد تأجير تمويلي.pdf",
        userManualName: "دليل المستخدم خدمة إحلال عقد تأجير تمويلي",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.FinanceLeaseCancel.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.FinanceLeaseCancel.serviceTitle",
        ),
        desc: i18n.t("OwnershipTransfer.FinanceLeaseCancel.serviceDesc"),
        name: "financeLeaseCancel",
        icon: <FinanceLeaseCancelIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/financeLease-cancel/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/financeLease-cancel/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/financeLease-cancel/requirements",
        category: "mortgageAndFinance",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/فسخ عقد تأجير تمويلي.pdf",
        userManualName: "دليل المستخدم خدمة فسخ عقد تأجير تمويلي",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.FinanceLeaseSelling.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.FinanceLeaseSelling.serviceTitle",
        ),
        desc: i18n.t("OwnershipTransfer.FinanceLeaseSelling.serviceDesc"),
        name: "financeLeaseSelling",
        icon: <FinanceLeaseSellingIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/financeLease-selling/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/financeLease-selling/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/financeLease-selling/requirements",
        category: "mortgageAndFinance",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/تمليك عقد تأجير تمويلي.pdf",
        userManualName: "دليل المستخدم خدمة تمليك عقد تأجير تمويلي",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.executeRetention.title"),
        serviceTitle: i18n.t("OwnershipTransfer.executeRetention.titleService"),
        desc: i18n.t("OwnershipTransfer.executeRetention.serviceDesc"),
        name: "executeRetention",
        icon: <SellingUrbanDevIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/execute-retention/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/execute-retention/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/execute-retention/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/executeRetention.pdf",
        userManualName:
          "دليل المستخدم خدمة تنفيذ الحجز على الأموال غير المنقولة",
        row: 4,
      },
      {
        label: i18n.t("OwnershipTransfer.releaseRetention.title"),
        serviceTitle: i18n.t("OwnershipTransfer.releaseRetention.titleService"),
        desc: i18n.t("OwnershipTransfer.releaseRetention.serviceDesc"),
        name: "releaseRetention",
        icon: <SellingUrbanDevIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/release-retention/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/release-retention/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/release-retention/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/releaseRetention.pdf",
        userManualName: "دليل المستخدم خدمة فك الحجز على الأموال غير المنقولة",
        row: 4,
      },
      {
        label: i18n.t("OwnershipTransfer.guaranteeCertificate.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.guaranteeCertificate.titleService",
        ),
        desc: i18n.t("OwnershipTransfer.guaranteeCertificate.serviceDesc"),
        name: "guaranteeCertificate",
        icon: <SellingUrbanDevIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/guarantee-certificate/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/guarantee-certificate/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/guarantee-certificate/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة شهادة كفالات.pdf",
        userManualName: "دليل المستخدم خدمة شهادة كفالات",
        row: 4,
      },
      {
        label: i18n.t("OwnershipTransfer.foreclosureSale.title"),
        serviceTitle: i18n.t("OwnershipTransfer.foreclosureSale.titleService"),
        desc: i18n.t("OwnershipTransfer.foreclosureSale.serviceDesc"),
        name: "foreclosureSale",
        icon: <SellingUrbanDevIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/foreclosure-sale/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/foreclosure-sale/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/foreclosure-sale/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة بيع مثقل بالرهن.pdf",
        userManualName: "دليل المستخدم خدمة بيع مثقل بالرهن",
        row: 4,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.exchange.title"),
        serviceTitle: i18n.t("OwnershipTransfer.exchange.titleService"),
        desc: i18n.t("OwnershipTransfer.exchange.serviceDesc"),
        name: "exchange",
        icon: <SellingUrbanDevIcon />,
        startUrl: "/government-services/dls/ownership-transfer/exchange/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/exchange/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/exchange/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl: "/User_Manuals/Ownership_User_Manual/خدمة المبادلة.pdf",
        userManualName: "دليل المستخدم خدمة المبادلة",
        row: 4,
      },
      {
        label: i18n.t("registration-services.farmLeasing.title"),
        serviceTitle: i18n.t("registration-services.farmLeasing.titleService"),
        desc: i18n.t("registration-services.farmLeasing.serviceDesc"),
        name: "farmLeasing",
        icon: <SellingUrbanDevIcon />,
        startUrl:
          "/government-services/dls/registration-services/farm-leasing/apply",
        descriptionUrl:
          "/government-services/dls/registration-services/farm-leasing/description",
        requirementsUrl:
          "/government-services/dls/registration-services/farm-leasing/requirements",
        category: "registrationServices",
        release: "1",
        userManualUrl: "/User_Manuals/RegistrationServices/خدمة المغارسة.pdf",
        userManualName: "دليل المستخدم خدمة المغارسة",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("registration-services.transferFarmLeasing.title"),
        serviceTitle: i18n.t(
          "registration-services.transferFarmLeasing.titleService",
        ),
        desc: i18n.t("registration-services.transferFarmLeasing.serviceDesc"),
        name: "transferFarmLeasing",
        icon: <SellingUrbanDevIcon />,
        startUrl:
          "/government-services/dls/registration-services/transfer-farm-leasing/apply",
        descriptionUrl:
          "/government-services/dls/registration-services/transfer-farm-leasing/description",
        requirementsUrl:
          "/government-services/dls/registration-services/transfer-farm-leasing/requirements",
        category: "registrationServices",
        release: "1",
        userManualUrl:
          "/User_Manuals/RegistrationServices/خدمة تحويل المغارسة.pdf",
        userManualName: "دليل المستخدم خدمة تحويل المغارسة",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("registration-services.cancelFarmLeasing.title"),
        serviceTitle: i18n.t(
          "registration-services.cancelFarmLeasing.titleService",
        ),
        desc: i18n.t("registration-services.cancelFarmLeasing.serviceDesc"),
        name: "cancelFarmLeasing",
        icon: <SellingUrbanDevIcon />,
        startUrl:
          "/government-services/dls/registration-services/cancel-farm-leasing/apply",
        descriptionUrl:
          "/government-services/dls/registration-services/cancel-farm-leasing/description",
        requirementsUrl:
          "/government-services/dls/registration-services/cancel-farm-leasing/requirements",
        category: "registrationServices",
        release: "1",
        userManualUrl:
          "/User_Manuals/RegistrationServices/خدمة فك المغارسة.pdf",
        userManualName: "دليل المستخدم خدمة فك المغارسة",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("registration-services.correctNameNationalId.title"),
        serviceTitle: i18n.t(
          "registration-services.correctNameNationalId.titleService",
        ),
        desc: i18n.t("registration-services.correctNameNationalId.serviceDesc"),
        name: "correctNameNationalId",
        icon: <SellingUrbanDevIcon />,
        startUrl:
          "/government-services/dls/registration-services/correct-name-national-id/apply",
        descriptionUrl:
          "/government-services/dls/registration-services/correct-name-national-id/description",
        requirementsUrl:
          "/government-services/dls/registration-services/correct-name-national-id/requirements",
        category: "registrationServices",
        release: "1",
        userManualUrl:
          "/User_Manuals/RegistrationServices/تصحيح الاسم وإضافة الرقم الوطني للمالكين على السجل العقاري.pdf",
        userManualName:
          "دليل المستخدم خدمة تصحيح الاسم وإضافة الرقم الوطني للمالكين على السجل العقاري",
        row: 1,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.authForHousingPurposes.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.authForHousingPurposes.titleService",
        ),
        desc: i18n.t("OwnershipTransfer.authForHousingPurposes.serviceDesc"),
        name: "authForHousingPurposes",
        icon: <SellingUrbanDevIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/authorization-service-for-housing-purposes/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/authorization-service-for-housing-purposes/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/authorization-service-for-housing-purposes/requirements",
        category: "govPropertyManagement",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة التفويض لغايات السكن.pdf",
        userManualName: "دليل المستخدم خدمة التفويض لغايات السكن",
        row: 1,
      },
      {
        label: i18n.t("OwnershipTransfer.leasingStateProperty.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.leasingStateProperty.titleService",
        ),
        desc: i18n.t("OwnershipTransfer.leasingStateProperty.serviceDesc"),
        name: "leasingStateProperty",
        icon: <SellingUrbanDevIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/leasing-state-property-lands-within-frontier-centers/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/leasing-state-property-lands-within-frontier-centers/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/leasing-state-property-lands-within-frontier-centers/requirements",
        category: "govPropertyManagement",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة تأجير اراضي املاك الدولة ضمن مراكز حدودية.pdf",
        userManualName:
          "دليل المستخدم خدمة تأجير أراضي أملاك الدولة ضمن المراكز الحدودية",
        row: 1,
      },
      {
        label: i18n.t("OwnershipTransfer.rentingStateProperty.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.rentingStateProperty.titleService",
        ),
        desc: i18n.t("OwnershipTransfer.rentingStateProperty.serviceDesc"),
        name: "rentingStateProperty",
        icon: <SellingUrbanDevIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/renting-state-property-lands/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/renting-state-property-lands/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/renting-state-property-lands/requirements",
        category: "govPropertyManagement",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة تأجير اراضي املاك الدولة تأجير مقالع.pdf",
        userManualName:
          "دليل المستخدم خدمة تأجير أراضي أملاك الدولة تاجير المقالع",
        row: 1,
      },
      {
        label: i18n.t("OwnershipTransfer.refundFees.title"),
        serviceTitle: i18n.t("OwnershipTransfer.refundFees.titleService"),
        desc: i18n.t("OwnershipTransfer.refundFees.serviceDesc"),
        name: "refundFees",
        icon: <RefundFeesIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/refund-of-collected-fees/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/refund-of-collected-fees/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/refund-of-collected-fees/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/رد الرسوم المستوفاة.pdf",
        userManualName: "دليل المستخدم خدمة رد الرسوم المستوفاة",
        row: 4,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.reconsiderAdministrativePrice.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.reconsiderAdministrativePrice.titleService",
        ),
        desc: i18n.t(
          "OwnershipTransfer.reconsiderAdministrativePrice.serviceDesc",
        ),
        name: "reconsiderAdministrativePrice",
        icon: <RefundFeesIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/reconsider-administrative-price/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/reconsider-administrative-price/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/reconsider-administrative-price/requirements",
        category: "ownership-transfer",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة طلب إعادة النظر في السعر الإداري.pdf",
        userManualName: "دليل المستخدم خدمة طلب إعادة النظر في السعر الإداري",
        row: 4,
        published: true,
      },

      {
        label: i18n.t("OwnershipTransfer.setLimits.title"),
        serviceTitle: i18n.t("OwnershipTransfer.setLimits.titleService"),
        desc: i18n.t("OwnershipTransfer.setLimits.serviceDesc"),
        name: "setLimits",
        icon: <RefundFeesIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/set-limits/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/set-limits/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/set-limits/requirements",
        showAtMyProperties: true,
        category: "survey",
        release: "1",
        userManualUrl: "/User_Manuals/survey/خدمة تثبيت حدود.pdf",
        userManualName: "دليل المستخدم خدمة تثبيت حدود",
        row: 1,
      },
      {
        label: i18n.t("OwnershipTransfer.demarcationSettlementLand.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.demarcationSettlementLand.titleService",
        ),
        desc: i18n.t("OwnershipTransfer.demarcationSettlementLand.serviceDesc"),
        name: "demarcationSettlementLand",
        icon: <RefundFeesIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/demarcation-of-a-road-on-settlement-land/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/demarcation-of-a-road-on-settlement-land/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/demarcation-of-a-road-on-settlement-land/requirements",
        showAtMyProperties: true,
        category: "survey",
        release: "1",
        userManualUrl: "/User_Manuals/survey/خدمة ترسيم طريق على ارض تسوية.pdf",
        userManualName: "دليل المستخدم خدمة ترسيم طريق على أرض تسوية",
        row: 1,
      },
      {
        label: i18n.t("OwnershipTransfer.replacementSettlementRoad.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.replacementSettlementRoad.titleService",
        ),
        desc: i18n.t("OwnershipTransfer.replacementSettlementRoad.serviceDesc"),
        name: "replacementSettlementRoad",
        icon: <RefundFeesIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/replacement-of-settlement-road/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/replacement-of-settlement-road/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/replacement-of-settlement-road/requirements",
        showAtMyProperties: true,
        category: "survey",
        release: "1",
        userManualUrl:
          "/User_Manuals/survey/خدمة استبدال طريق على ارض تسوية.pdf",
        userManualName: "دليل المستخدم خدمة إستبدال طريق على أرض تسوية",
        row: 1,
      },
      {
        label: i18n.t("OwnershipTransfer.cancellationSettlementLand.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.cancellationSettlementLand.titleService",
        ),
        desc: i18n.t(
          "OwnershipTransfer.cancellationSettlementLand.serviceDesc",
        ),
        name: "cancellationSettlementLand",
        icon: <RefundFeesIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/cancellation-of-a-road-on-settlement-land/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/cancellation-of-a-road-on-settlement-land/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/cancellation-of-a-road-on-settlement-land/requirements",
        showAtMyProperties: true,
        category: "survey",
        release: "1",
        userManualUrl: "/User_Manuals/survey/خدمة الغاء طريق على ارض تسوية.pdf",
        userManualName: "دليل المستخدم خدمة إلغاء طريق على أرض تسوية",
        row: 1,
      },
      {
        label: i18n.t("OwnershipTransfer.providingInfoOwnedProperty.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.providingInfoOwnedProperty.titleService",
        ),
        desc: i18n.t(
          "OwnershipTransfer.providingInfoOwnedProperty.serviceDesc",
        ),
        name: "providingInfoOwnedProperty",
        icon: <RefundFeesIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/providing-information-about-the-owned-property/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/providing-information-about-the-owned-property/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/providing-information-about-the-owned-property/requirements",
        showAtMyProperties: true,
        category: "govPropertyManagement",
        release: "1",
        userManualUrl:
          "/User_Manuals/survey/خدمة تزويد معلومات عن عقار مستملك.pdf",
        userManualName: "دليل المستخدم خدمة تزويد معلومات عن العقار المستملك",
        row: 1,
      },
      // {
      //   label: i18n.t("OwnershipTransfer.changeStatementRequest.title"),
      //   serviceTitle: i18n.t(
      //     "OwnershipTransfer.changeStatementRequest.titleService"
      //   ),
      //   desc: i18n.t("OwnershipTransfer.changeStatementRequest.serviceDesc"),
      //   name: "changeStatementRequest",
      //   icon: <RefundFeesIcon />,
      //   startUrl:
      //     "/government-services/dls/ownership-transfer/change-statement-request/apply",
      //   descriptionUrl:
      //     "/government-services/dls/ownership-transfer/change-statement-request/description",
      //   requirementsUrl:
      //     "/government-services/dls/ownership-transfer/change-statement-request/requirements",
      //   category: "survey",
      //   release: "2",
      //   userManualUrl: "/User_Manuals/survey/طلب بيان التغيير.pdf",
      //   userManualName: "دليل المستخدم خدمة طلب بيان التغيير",
      //   row: 2,
      // },
      {
        label: i18n.t("OwnershipTransfer.providingMapsPanelsAndIndexes.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.providingMapsPanelsAndIndexes.titleService",
        ),
        desc: i18n.t(
          "OwnershipTransfer.providingMapsPanelsAndIndexes.serviceDesc",
        ),
        name: "providingMapsPanelsAndIndexes",
        icon: <RefundFeesIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/providing-maps-panels-and-indexes/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/providing-maps-panels-and-indexes/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/providing-maps-panels-and-indexes/requirements",
        category: "survey",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/تزويد بخرائط و فهارس.pdf",
        userManualName: "دليل المستخدم خدمة تزويد بخرائط ولوحات وفهارس",
        row: 2,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.channelDemarcation.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.channelDemarcation.titleService",
        ),
        desc: i18n.t("OwnershipTransfer.channelDemarcation.serviceDesc"),
        name: "channelDemarcation",
        icon: <RefundFeesIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/channel-demarcation/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/channel-demarcation/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/channel-demarcation/requirements",
        category: "survey",
        release: "1",
        userManualUrl: "/User_Manuals/Ownership_User_Manual/ترسيم قناة.pdf",
        userManualName: "دليل المستخدم خدمة ترسيم قناة",
        row: 2,
        published: true,
      },
      {
        label: i18n.t(
          "OwnershipTransfer.certifiedCopyoftheBorderFixingDetectionReport.title",
        ),
        serviceTitle: i18n.t(
          "OwnershipTransfer.certifiedCopyoftheBorderFixingDetectionReport.titleService",
        ),
        desc: i18n.t(
          "OwnershipTransfer.certifiedCopyoftheBorderFixingDetectionReport.serviceDesc",
        ),
        name: "certifiedCopyoftheBorderFixingDetectionReport",
        icon: <RefundFeesIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/certified-copy-of-the-border-fixing-detection-report/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/certified-copy-of-the-border-fixing-detection-report/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/certified-copy-of-the-border-fixing-detection-report/requirements",
        category: "survey",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/صورة طبق الاصل عن كشف تثبيت حدود.pdf",
        userManualName: "دليل المستخدم خدمة صورة طبق الاصل عن كشف تثبيت حدود",
        row: 2,
        published: true,
      },
      {
        label: i18n.t("OwnershipTransfer.correctServeyInfo.title"),
        serviceTitle: i18n.t(
          "OwnershipTransfer.correctServeyInfo.titleService",
        ),
        desc: i18n.t("OwnershipTransfer.correctServeyInfo.serviceDesc"),
        name: "correctServeyInfo",
        icon: <RefundFeesIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/correct-servey-info/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/correct-servey-info/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/correct-servey-info/requirements",
        category: "survey",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة تصحيح وتعديل معلومات مساحية.pdf",
        userManualName: "دليل المستخدم خدمة تصحيح وتعديل معلومات مساحية",
        row: 2,
        published: true,
      },
      {
        label: i18n.t(
          "OwnershipTransfer.collectingPropertiesImproveAppearance.title",
        ),
        serviceTitle: i18n.t(
          "OwnershipTransfer.collectingPropertiesImproveAppearance.titleService",
        ),
        desc: i18n.t(
          "OwnershipTransfer.collectingPropertiesImproveAppearance.serviceDesc",
        ),
        name: "collectingPropertiesImproveAppearance",
        icon: <RefundFeesIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/collecting-properties-improve-appearance/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/collecting-properties-improve-appearance/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/collecting-properties-improve-appearance/requirements",
        category: "survey",
        release: "1",
        userManualUrl:
          "/User_Manuals/Ownership_User_Manual/خدمة تجميع ملكيات لغايات تحسين أشكال.pdf",
        userManualName: "دليل المستخدم خدمة تجميع ملكيات لغايات تحسين أشكال",
        row: 2,
        published: true,
      },
      // Real Estate Office Services
      {
        label: i18n.t("realEstateOfficeServices.addRealEstateOfficeLicense"),
        icon: <GiveOffice />,
        startUrl: "/government-services/dls/real-estate-office/grant/apply",
        descriptionUrl:
          "/government-services/dls/real-estate-office/grant/description",
        requirementsUrl:
          "/government-services/dls/real-estate-office/grant/requirements",
        category: "real-estate-office",
        release: "1",
        userManualUrl:
          "/User_Manuals/Legal_Affairs_User_Manual/RSO/Grant_RSO.pdf",
        userManualName: "دليل المستخدم منح رخصة مكتب عقاري",
        published: false,
      },
      {
        label: i18n.t("realEstateOfficeServices.renewRealEstateOfficeLicense"),
        icon: <RenewOffice />,
        startUrl: "/government-services/dls/real-estate-office/renew/apply",
        descriptionUrl:
          "/government-services/dls/real-estate-office/renew/description",
        requirementsUrl:
          "/government-services/dls/real-estate-office/renew/requirements",
        category: "real-estate-office",
        release: "1",
        userManualUrl:
          "/User_Manuals/Legal_Affairs_User_Manual/RSO/Renew_RSO.pdf",
        userManualName: "دليل المستخدم خدمة تجديد رخصة مكتب عقاري",
        published: true,
      },
      {
        label: i18n.t(
          "realEstateOfficeServices.suspenseRealEstateOfficeLicense",
        ),
        icon: <DeleteOffice />,
        startUrl: "/government-services/dls/real-estate-office/suspend/apply",
        descriptionUrl:
          "/government-services/dls/real-estate-office/suspend/description",
        requirementsUrl:
          "/government-services/dls/real-estate-office/suspend/requirements",
        category: "real-estate-office",
        release: "1",
        userManualUrl:
          "/User_Manuals/Legal_Affairs_User_Manual/RSO/Suspense_Cancel_RSO.pdf",
        userManualName: "دليل المستخدم خدمة الغاء او ايقاف رخصة مكتب عقاري",
        published: true,
      },
      {
        label: i18n.t("realEstateOfficeServices.cancelRealEstateOfficeLicense"),
        icon: <DeleteOffice />,
        startUrl: "/government-services/dls/real-estate-office/cancel/apply",
        descriptionUrl:
          "/government-services/dls/real-estate-office/cancel/description",
        requirementsUrl:
          "/government-services/dls/real-estate-office/cancel/requirements",
        category: "real-estate-office",
        release: "1",
        userManualUrl:
          "/User_Manuals/Legal_Affairs_User_Manual/RSO/Suspense_Cancel_RSO.pdf",
        userManualName: "دليل المستخدم خدمة الغاء او ايقاف رخصة مكتب عقاري",
        published: true,
      },
      // Real Estate Appraiser Services
      {
        label: i18n.t(
          "realEstateAppraiserServices.addRealEstateAppraiserLicense",
        ),
        icon: <GiveEstimator />,
        startUrl: "/government-services/dls/real-estate-appraiser/grant/apply",
        descriptionUrl:
          "/government-services/dls/real-estate-appraiser/grant/description",
        requirementsUrl:
          "/government-services/dls/real-estate-appraiser/grant/requirements",
        category: "real-estate-appraiser",
        release: "1",
        userManualUrl:
          "/User_Manuals/Legal_Affairs_User_Manual/EST/Grant_EST_User_Manual.pdf",
        userManualName: "دليل المستخدم خدمة منح رخصة مقدر عقاري",
        published: false,
      },
      {
        label: i18n.t(
          "realEstateAppraiserServices.renewRealEstateAppraiserLicense",
        ),
        icon: <DeleteRenewEstimator />,
        startUrl: "/government-services/dls/real-estate-appraiser/renew/apply",
        requirementsUrl:
          "/government-services/dls/real-estate-appraiser/renew/requirements",
        descriptionUrl:
          "/government-services/dls/real-estate-appraiser/renew/description",
        category: "real-estate-appraiser",
        release: "1",
        userManualUrl:
          "/User_Manuals/Legal_Affairs_User_Manual/EST/Renew_Suspense_Cancel_EST.pdf",
        userManualName: "دليل المستخدم تجديد أو الغاء أو ايقاف رخصة مقدر عقاري",
        published: true,
      },
      {
        label: i18n.t(
          "realEstateAppraiserServices.suspendRealEstateAppraiserLicense",
        ),
        icon: <DeleteRenewEstimator />,
        startUrl:
          "/government-services/dls/real-estate-appraiser/suspend/apply",
        requirementsUrl:
          "/government-services/dls/real-estate-appraiser/suspend/requirements",
        descriptionUrl:
          "/government-services/dls/real-estate-appraiser/suspend/description",
        category: "real-estate-appraiser",
        release: "1",
        userManualUrl:
          "/User_Manuals/Legal_Affairs_User_Manual/EST/Renew_Suspense_Cancel_EST.pdf",
        userManualName: "دليل المستخدم تجديد أو الغاء أو ايقاف رخصة مقدر عقاري",
        published: true,
      },
      {
        label: i18n.t(
          "realEstateAppraiserServices.cancelRealEstateAppraiserLicense",
        ),
        icon: <DeleteRenewEstimator />,
        startUrl: "/government-services/dls/real-estate-appraiser/cancel/apply",
        requirementsUrl:
          "/government-services/dls/real-estate-appraiser/cancel/requirements",
        descriptionUrl:
          "/government-services/dls/real-estate-appraiser/cancel/description",
        category: "real-estate-appraiser",
        release: "1",
        userManualUrl:
          "/User_Manuals/Legal_Affairs_User_Manual/EST/Renew_Suspense_Cancel_EST.pdf",
        userManualName: "دليل المستخدم تجديد أو الغاء أو ايقاف رخصة مقدر عقاري",
        published: true,
      },
      // Surveyor Services
      {
        label: i18n.t("surveyorServices.addSurveyorLicense"),
        icon: <GiveServey />,
        startUrl: "/government-services/dls/surveyor/grant/apply",
        descriptionUrl: "/government-services/dls/surveyor/grant/description",
        requirementsUrl: "/government-services/dls/surveyor/grant/requirements",
        category: "surveyor",
        release: "1",
        userManualUrl:
          "/User_Manuals/Legal_Affairs_User_Manual/SUV/Grant_SUV.pdf",
        userManualName: "دليل المستخدم خدمة منح رخصة مساح",
        published: false,
      },
      {
        label: i18n.t("surveyorServices.renewSurveyorLicense"),
        icon: <RenewServey />,
        startUrl: "/government-services/dls/surveyor/renew/apply",
        descriptionUrl: "/government-services/dls/surveyor/renew/description",
        requirementsUrl: "/government-services/dls/surveyor/renew/requirements",
        category: "surveyor",
        release: "1",
        userManualUrl:
          "/User_Manuals/Legal_Affairs_User_Manual/SUV/Renew_SUV.pdf",
        userManualName: "دليل المستخدم  تجديد رخصة مساح",
        published: true,
      },
      {
        label: i18n.t("surveyorServices.susbendServeyorTitle"),
        icon: <DeleteServey />,
        startUrl: "/government-services/dls/surveyor/suspend/apply",
        descriptionUrl: "/government-services/dls/surveyor/suspend/description",
        // requirementsUrl: "/government-services/dls/surveyor/suspend-cancel/requirements",
        category: "surveyor",
        release: "1",
        userManualUrl:
          "/User_Manuals/Legal_Affairs_User_Manual/SUV/Suspense_Cancel_SUV.pdf",
        userManualName: "دليل المستخدم خدمة الغاء او ايقاف رخصة مساح",
        published: true,
      },
      {
        label: i18n.t("surveyorServices.cancelServeyorTitle"),
        icon: <DeleteServey />,
        startUrl: "/government-services/dls/surveyor/cancel/apply",
        descriptionUrl: "/government-services/dls/surveyor/cancel/description",
        // requirementsUrl: "/government-services/dls/surveyor/suspend-cancel/requirements",
        category: "surveyor",
        release: "1",
        userManualUrl:
          "/User_Manuals/Legal_Affairs_User_Manual/SUV/Suspense_Cancel_SUV.pdf",
        userManualName: "دليل المستخدم خدمة الغاء او ايقاف رخصة مساح",
        published: true,
      },
      // Efraz
      {
        label: i18n.t("Efraz.Partners.title"),
        serviceTitle: i18n.t("Efraz.Partners.serviceTitle"),
        desc: i18n.t("Efraz.Partners.serviceDescription"),
        icon: <PartnerLandsIcon />,
        startUrl: "/government-services/dls/efraz/partner-lands/apply",
        descriptionUrl:
          "/government-services/dls/efraz/partner-lands/description",
        requirementsUrl:
          "/government-services/dls/efraz/partner-lands/requirements",
        category: "efraz",
        release: "1",
        name: "efrazPartnersLands",
        row: 1,
        userManualUrl: "/User_Manuals/Efraz_User_Manual/افراز شركاء اراضي.pdf",
        userManualName: "دليل المستخدم خدمة إفراز الشركاء للأراضي",
        published: true,
      },
      {
        label: i18n.t("Efraz.Partners.apartmentTitle"),
        serviceTitle: i18n.t("Efraz.Partners.apartmentServiceTitle"),
        desc: i18n.t("Efraz.Partners.apartmentServiceDescription"),
        icon: <PartnerApartmentsIcon />,
        startUrl: "/government-services/dls/efraz/partner-apartments/apply",
        descriptionUrl:
          "/government-services/dls/efraz/partner-apartments/description",
        requirementsUrl:
          "/government-services/dls/efraz/partner-apartments/requirements",
        category: "efraz",
        release: "1",
        name: "efrazPartnerApartments",
        row: 1,
        userManualUrl: "/User_Manuals/Efraz_User_Manual/إفراز شركاء  للشقق.pdf",
        userManualName: "دليل المستخدم خدمة إفراز الشركاء للشقق",
        published: true,
      },
      {
        label: i18n.t("Efraz.tawheed.title"),
        serviceTitle: i18n.t("Efraz.tawheed.serviceTitle"),
        desc: i18n.t("Efraz.tawheed.serviceDescription"),
        icon: <MergeLandsIcon />,
        startUrl: "/government-services/dls/efraz/tawheed-lands/apply",
        descriptionUrl:
          "/government-services/dls/efraz/tawheed-lands/description",
        requirementsUrl:
          "/government-services/dls/efraz/tawheed-lands/requirements",
        category: "efraz",
        release: "1",
        name: "efrazTawheed",
        row: 1,
        userManualUrl:
          "/User_Manuals/Efraz_User_Manual/إفراز التوحيد للأراضي.pdf",
        userManualName: "دليل المستخدم خدمة إفراز التوحيد للأراضي",
        published: true,
      },
      {
        label: i18n.t("Efraz.tawheed.apartmentTitle"),
        serviceTitle: i18n.t("Efraz.tawheed.apartmentServiceTitle"),
        desc: i18n.t("Efraz.tawheed.apartmentServiceDescription"),
        icon: <MergeApartmentsIcon />,
        startUrl: "/government-services/dls/efraz/tawheed-apartments/apply",
        descriptionUrl:
          "/government-services/dls/efraz/tawheed-apartments/description",
        requirementsUrl:
          "/government-services/dls/efraz/tawheed-apartments/requirements",
        category: "efraz",
        release: "1",
        name: "efrazTawheedApartments",
        row: 1,
        userManualUrl: "/User_Manuals/Efraz_User_Manual/افراز توحيد للشقق.pdf",
        userManualName: "دليل المستخدم خدمة إفراز التوحيد للشقق",
        published: true,
      },
      {
        label: i18n.t("Efraz.Split.title"),
        serviceTitle: i18n.t("Efraz.Split.serviceTitle"),
        desc: i18n.t("Efraz.Split.serviceDescription"),
        icon: <SplitLandsIcon />,
        startUrl: "/government-services/dls/efraz/split-lands/apply",
        descriptionUrl:
          "/government-services/dls/efraz/split-lands/description",
        requirementsUrl:
          "/government-services/dls/efraz/split-lands/requirements",
        category: "efraz",
        release: "1",
        name: "efrazSplitLands",
        row: 1,
        userManualUrl:
          "/User_Manuals/Efraz_User_Manual/إفراز التجزئة للأراضي.pdf",
        userManualName: "دليل المستخدم خدمة إفراز التجزئة للأراضي",
        published: true,
      },
      {
        label: i18n.t("Efraz.Split.apartmentTitle"),
        serviceTitle: i18n.t("Efraz.Split.apartmentServiceTitle"),
        desc: i18n.t("Efraz.Split.apartmentServiceDescription"),
        icon: <SplitApartmentsIcon />,
        startUrl: "/government-services/dls/efraz/split-apartments/apply",
        descriptionUrl:
          "/government-services/dls/efraz/split-apartments/description",
        requirementsUrl:
          "/government-services/dls/efraz/split-apartments/requirements",
        category: "efraz",
        release: "1",
        name: "efrazSplitApartments",
        row: 1,
        userManualUrl:
          "/User_Manuals/Efraz_User_Manual/إفراز التجزئة للشقق.pdf",
        userManualName: "دليل المستخدم خدمة إفراز التجزئة للشقق",
        published: true,
      },
      {
        label: i18n.t("Efraz.Judicial.title"),
        serviceTitle: i18n.t("Efraz.Judicial.serviceTitle"),
        desc: i18n.t("Efraz.Judicial.serviceDescription"),
        icon: <JudicialLandsIcon />,
        startUrl: "/government-services/dls/efraz/judicial-lands/apply",
        descriptionUrl:
          "/government-services/dls/efraz/judicial-lands/description",
        requirementsUrl:
          "/government-services/dls/efraz/judicial-lands/requirements",
        category: "efraz",
        release: "1",
        name: "efrazJudicialLands",
        row: 1,
        userManualUrl:
          "/User_Manuals/Efraz_User_Manual/افراز قضائي للاراضي.pdf",
        userManualName: "دليل المستخدم خدمة الإفراز القضائي للأراضي",
        published: true,
      },
      {
        label: i18n.t("Efraz.Judicial.apartmentTitle"),
        serviceTitle: i18n.t("Efraz.Judicial.apartmentServiceTitle"),
        desc: i18n.t("Efraz.Judicial.apartmentServiceDescription"),
        icon: <JudicialApartmentsIcon />,
        startUrl: "/government-services/dls/efraz/judicial-apartments/apply",
        descriptionUrl:
          "/government-services/dls/efraz/judicial-apartments/description",
        requirementsUrl:
          "/government-services/dls/efraz/judicial-apartments/requirements",
        category: "efraz",
        release: "1",
        name: "efrazJudicialApartments",
        row: 1,
        userManualUrl:
          "/User_Manuals/Efraz_User_Manual/إفراز قضائي   للشقق.pdf",
        userManualName: "دليل المستخدم خدمة الإفراز القضائي للشقق",
        published: true,
      },
      {
        label: i18n.t("Efraz.selling.title"),
        serviceTitle: i18n.t("Efraz.selling.serviceTitle"),
        desc: i18n.t("Efraz.selling.serviceDescription"),
        icon: <SellingLandsIcon />,
        startUrl: "/government-services/dls/efraz/selling-lands/apply",
        descriptionUrl:
          "/government-services/dls/efraz/selling-lands/description",
        requirementsUrl:
          "/government-services/dls/efraz/selling-lands/requirements",
        category: "efraz",
        release: "1",
        name: "efrazSellingLands",
        row: 1,
        userManualUrl:
          "/User_Manuals/Efraz_User_Manual/افراز بقصد البيع  اراضي.pdf",
        userManualName: "دليل المستخدم خدمة الإفراز بقصد البيع للأراضي",
        published: true,
      },
      {
        label: i18n.t("Efraz.selling.apartmentTitle"),
        serviceTitle: i18n.t("Efraz.selling.apartmentServiceTitle"),
        desc: i18n.t("Efraz.selling.apartmentServiceDescription"),
        icon: <SellingApartmentsIcon />,
        startUrl: "/government-services/dls/efraz/selling-apartments/apply",
        descriptionUrl:
          "/government-services/dls/efraz/selling-apartments/description",
        requirementsUrl:
          "/government-services/dls/efraz/selling-apartments/requirements",
        category: "efraz",
        release: "1",
        name: "efrazSellingApartments",
        row: 1,
        userManualUrl:
          "/User_Manuals/Efraz_User_Manual/إفراز بقصد البيع للشقق.pdf",
        userManualName: "دليل المستخدم خدمة الإفراز بقصد البيع للشقق",
        published: true,
      },
      // Mortgage
      {
        label: i18n.t("mortgageServices.mortgage"),
        serviceTitle: i18n.t("mortgageServices.mortgageServiceTitle"),
        desc: i18n.t("mortgageServices.mortgageServiceDesc"),
        name: "mortgage",
        icon: <MortgageIcon />,
        startUrl: "/government-services/dls/mortgage/mortgage/apply",
        descriptionUrl:
          "/government-services/dls/mortgage/mortgage/description",
        requirementsUrl:
          "/government-services/dls/mortgage/mortgage/requirements",
        category: "mortgageAndFinance",
        release: "1",
        showAtMyProperties: true,
        disableByDistrict: true,
        userManualUrl: "/User_Manuals/Mortgage/خدمة تأمين الرهن العقاري.pdf",
        userManualName: "دليل المستخدم خدمة التأمين (الرهن)",
        published: true,
        row: 1,
      },
      {
        label: i18n.t("mortgageServices.unlockInsurance"),
        serviceTitle: i18n.t("Mortgages.MortgageTransfer.serviceTitle"),
        desc: i18n.t("Mortgages.MortgageTransfer.serviceDesc"),
        name: "mortgageRelease",
        icon: <MortgageReleaseIcon />,
        startUrl: "/government-services/dls/mortgage/mortgage-release/apply",
        descriptionUrl:
          "/government-services/dls/mortgage/mortgage-release/description",
        requirementsUrl:
          "/government-services/dls/mortgage/mortgage-release/requirements",
        category: "mortgageAndFinance",
        release: "1",
        userManualUrl: "/User_Manuals/Mortgage/خدمة فك التأمين.pdf",
        userManualName: "دليل المستخدم خدمة فك التأمين (الرهن)",
        published: true,
        row: 1,
      },
      {
        label: i18n.t("Mortgages.MortgageTransfer.title"),
        serviceTitle: i18n.t("Mortgages.MortgageTransfer.serviceTitle"),
        desc: i18n.t("Mortgages.MortgageTransfer.serviceDesc"),
        name: "mortgageTransfer",
        icon: <MortgageTransferIcon />,
        startUrl: "/government-services/dls/mortgage/mortgage-transfer/apply",
        descriptionUrl:
          "/government-services/dls/mortgage/mortgage-transfer/description",
        requirementsUrl:
          "/government-services/dls/mortgage/mortgage-transfer/requirements",
        category: "mortgageAndFinance",
        release: "1",
        userManualUrl: "/User_Manuals/Mortgage/تحويل التأمين.pdf",
        userManualName: "دليل المستخدم خدمة تحويل التأمين (الرهن)",
        published: true,
        row: 1,
      },
      // Agencies
      {
        label: i18n.t("agencyAccreditation.title"),
        serviceTitle: i18n.t("agencyAccreditation.title"),
        desc: i18n.t("agencyAccreditation.serviceDescription"),
        name: "agencyAccreditation",
        icon: <AgencyAccreditationIcon />,
        startUrl:
          "/government-services/dls/ownership-transfer/agency-accreditation/apply",
        descriptionUrl:
          "/government-services/dls/ownership-transfer/agency-accreditation/description",
        requirementsUrl:
          "/government-services/dls/ownership-transfer/agency-accreditation/requirements",
        category: "agencies",
        release: "1",
        userManualUrl: "/User_Manuals/Agency/اعتماد الوكالة.pdf",
        userManualName: "دليل المستخدم خدمة اعتماد الوكالة",
      },
      {
        label: i18n.t(
          "investmentServices.nonJordanianOwnershipApprovals.title",
        ),
        serviceTitle: i18n.t(
          "investmentServices.nonJordanianOwnershipApprovals.title",
        ),
        desc: i18n.t(
          "investmentServices.nonJordanianOwnershipApprovals.serviceDescription",
        ),
        name: "nonJordanianOwnershipApprovals",
        serviceID: 1,
        // icon: <AgencyAccreditationIcon />,
        // startUrl:
        //   "/government-services/dls/investment-services/agency-accreditation/apply",
        // descriptionUrl:
        //   "/government-services/dls/investment-services/agency-accreditation/description",
        // requirementsUrl:
        //   "/government-services/dls/investment-services/agency-accreditation/requirements",
        category: "investmentServicesImproved",
        release: "1",
        published: true,
        // userManualUrl: "/User_Manuals/Agency/اعتماد الوكالة.pdf",
        // userManualName: "دليل المستخدم خدمة اعتماد الوكالة",
      },
      {
        label: i18n.t("investmentServices.legalEntityOwnershipApprovals.title"),
        serviceTitle: i18n.t(
          "investmentServices.legalEntityOwnershipApprovals.title",
        ),
        desc: i18n.t(
          "investmentServices.legalEntityOwnershipApprovals.serviceDescription",
        ),
        name: "legalEntityOwnershipApprovals",
        serviceID: 2,
        // icon: <AgencyAccreditationIcon />,
        // startUrl:
        //   "/government-services/dls/investment-services/agency-accreditation/apply",
        // descriptionUrl:
        //   "/government-services/dls/investment-services/agency-accreditation/description",
        // requirementsUrl:
        //   "/government-services/dls/investment-services/agency-accreditation/requirements",
        category: "investmentServicesImproved",
        release: "1",
        published: true,
        // userManualUrl: "/User_Manuals/Agency/اعتماد الوكالة.pdf",
        // userManualName: "دليل المستخدم خدمة اعتماد الوكالة",
      },
    ],
    certStatuses: [
      { code: 1, action: "granted", status: "active" },
      { code: 2, action: "renewed", status: "active" },
      { code: 3, action: "stoped", status: "inActive" },
      { code: 4, action: "canceled", status: "removed" },
    ],
    mortgageClasses: [
      {
        label: i18n.t("mortgageServices.first"),
        value: "first",
      },
      {
        label: i18n.t("mortgageServices.second"),
        value: "second",
      },
      {
        label: i18n.t("mortgageServices.third"),
        value: "third",
      },
      {
        label: i18n.t("mortgageServices.fourth"),
        value: "fourth",
      },
      {
        label: i18n.t("mortgageServices.fifth"),
        value: "fifth",
      },
      {
        label: i18n.t("mortgageServices.sixth"),
        value: "sixth",
      },
    ],
    authorities: [
      {
        label: "سلطة وادي الأردن",
        eLabel: "Jordan Valley Authority",
        value: "JVA",
        code: "DLS1011",
      },
      {
        label: "سلطة اقليم البتراء",
        eLabel: "Petra Region Authority",
        value: "PETRA",
        code: "DLS1022",
      },
      {
        label: "سلطة منطقة العقبة",
        eLabel: "Aqaba Zone Authority",
        value: "ASEZA",
        code: "DLS1019",
      },
      {
        label: "مؤسسة الاسكان والتطوير الحضري",
        eLabel: "Urban Development Corporation",
        value: "URBANDEV",
        code: "DLS1020",
      },
    ],
    userAuthTypes: (t) => [
      // {
      //   label: t("signup.jordanian"),
      //   value: {
      //     label: t("signup.jordanian"),
      //     id: 1,
      //   },
      // },
      {
        label: t("signup.nonJordanian"),
        value: {
          label: t("signup.nonJordanian"),
          id: 2,
        },
      },
      {
        label: t("signup.corporateCompanies"),
        value: {
          label: t("signup.corporateCompanies"),
          id: 3,
        },
      },
      {
        label: t("signup.governmentalEntities"),
        value: {
          label: t("signup.governmentalEntities"),
          id: 4,
        },
      },
      {
        label: t("signup.organizationsAndAssociations"),
        value: {
          label: t("signup.organizationsAndAssociations"),
          id: 7,
        },
      },
      {
        label: t("signup.realEstateOffice"),
        value: {
          label: t("signup.realEstateOffice"),
          id: 8,
        },
      },
    ],
  };

  data.config = { ...config };
}

// i18next seems ready -> initial fill translations
if (i18n.isInitialized) {
  updateTranslations();
}

// reset translations to new values on language change
i18n.on("languageChanged", function (lng) {
  updateTranslations();
});

// we loaded some translation file? reset needed?!?
// https://www.i18next.com/overview/api#store-events
i18n.on("loaded", function (lng) {
  updateTranslations();
});
export default data.config;

export function configFun() {
  return data.config;
}
